export const getImages = (imageName) => {
    var image = '';
    try {
        image = require(`../assets/img/${imageName}`);
    } catch (err) {
        image = require(`../assets/img/logos/no_image-512.webp`);
    }
    return image;
}